import { server, toastr } from '@/services/'

const state = {
  items: [],
  isFetching: false,
  user: {}
}

const getters = {
  getByUACode: (state) => (uaCode) => {
    return state.items.find((obj) => { return obj.USER_ACCOUNT_CODE === uaCode })
  },
  getNameByUACode: (state) => (uaCode) => {
    let profile = state.items.find((obj) => { return obj.USER_ACCOUNT_CODE === uaCode })
    if (profile) {
      return `${profile.FIRST_NAME} ${profile.LAST_NAME}`
    } else {
      return {}
    }
  }
}

const mutations = {
  setItems (state, payload) {
    state.items = payload
  },
  setIsFetching (state, payload) {
    state.isFetching = payload
  },
  setUser (state, payload) {
    state.user = payload
  }
}

const actions = {

  getAll ({ commit }) {
    return new Promise((resolve, reject) => {
      server.get('/getUP').then(
        resp => {
          commit('setItems', _.orderBy(resp.data.msgContent.data, 'FIRST_NAME'))
          resolve(true)
        },
        err => {
          reject(err.response)
        }
      )
    })
  },
  updateProfile({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      server.post(payload.apiUrl, payload.reqBody).then(
        resp => {
          toastr.updateSuccess()
          dispatch('getAll')
          resolve()
        },
        err => {
          toastr.serverError()
          reject()
        }
      )
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
